/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Tv_Signin_TitleInputs */

const de_login_tv_signin_title = /** @type {(inputs: Login_Tv_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerät anmelden`)
};

/** @type {(inputs: Login_Tv_Signin_TitleInputs) => LocalizedString} */
const en_login_tv_signin_title = de_login_tv_signin_title;

/**

* @param {Login_Tv_Signin_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_tv_signin_title = /** @type {((inputs?: Login_Tv_Signin_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Tv_Signin_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_tv_signin_title(inputs)
	return en_login_tv_signin_title(inputs)
});